import { push } from 'react-router-redux'
import Hashids from 'hashids';

import revokeTokenHandler from '../../pattern_utilities/revokeTokenHandler';
import { setCurrentTeam, unsetCurrentTeam } from '../actions.export';

var pf_config = require('../../pf_config.json');
var Cookies = require('js-cookie');
var hashids = new Hashids('k100p');

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// LOAD PATTERN
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const pmSetCurrentPattern = data => ({
  type: 'SET_CURRENT_PATTERN',
  gtag: {
    event_category: 'pattern',
    event_action: 'set_current'
  },
  data
})


export const requestLoadPattern = data => ({
  type: 'REQUEST_LOAD_PATTERN',
  gtag: {
    event_category: 'pattern',
    event_action: 'request'
  },
  data
})

export const receiveLoadPatternSuccess = data => ({
  type: 'RECEIVE_LOAD_PATTERN_SUCCESS',
  gtag: {
    event_category: 'pattern',
    event_action: 'success'
  },
  data
})

export const receiveLoadPatternFail = data => ({
  type: 'RECEIVE_LOAD_PATTERN_FAIL',
  gtag: {
    event_category: 'pattern',
    event_action: 'fail'
  },
  data
})

export const tryToLoadPattern = data => (dispatch, getState) => {
  dispatch(requestLoadPattern(data));

  var headers = { "Content-Type": "application/json" }
  var token = Cookies.get(process.env.REACT_APP_COOKIE_AUTH);
  if(token) headers.Authorization = "Bearer " + token;


  // for user request
  var url = '/api/patterns/id/' + data.id;

  let team = getState().team;
 
  let team_cookie = Cookies.get(process.env.REACT_APP_CURRENT_TEAM);
  let user = getState().user;
  if(team_cookie){
    url += '/as-team/' + window.atob(team_cookie);
  }

  return fetch(url, {
      method: 'get',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      let user = getState().user;
      if(user.isLoggedIn && user.id == json.scope){
        json.saved = true;
        json.linkedToServer = true;
      }

      dispatch(receiveLoadPatternSuccess(json));
      if(data.setCurrent) dispatch(pmSetCurrentPattern({cacheID: json.id }));
    })
    .catch((e, response) => {
      console.log(e, response);

      if(e.message === "Missing your library card."){
        let url = "/sign-up?after=" + window.btoa("/pat/" + hashids.encode(data.id));
        url += "&p=" + window.btoa(data.id);
        url += "&in=" + window.btoa("The perfect pattern");
        url += "&tg=" + window.btoa("Sign up for free, no tricks just treats.");
        dispatch(push(url));
      } else {
        dispatch(push('/404'));
      }

      revokeTokenHandler(e);
      dispatch(receiveLoadPatternFail({errors:e, lastSubmit: data}));
    })
}



// WEBPACK FOOTER //
// ./src/actions/pattern/a.p.GET.load-pattern.js